"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const BulkDownloader_vue_1 = __importDefault(require("./BulkDownloader.vue"));
const trans_1 = require("@common/tsutils/trans");
let ConfigurationSchemeLine = class ConfigurationSchemeLine extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isDownloading = false;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get lineSamples() {
        return this.line.samplesInside;
    }
    get lineSamplesCount() {
        return this.lineSamples.length;
    }
    get title() {
        const stdDepths = [0, 1];
        if (stdDepths.includes(this.depth))
            return this.line.name;
        return 'T' + this.line.time;
    }
    get subtitle() {
        let treatments = [];
        let times = [];
        if (this.depth === 0) {
            for (let treatment of this.line.treatments) {
                treatments.push(treatment.name);
                for (let time of treatment.times) {
                    if (!times.includes(time.time)) {
                        times.push(time.time);
                    }
                }
            }
            return `${treatments.length} ${(0, trans_1.trans)('trialsSummaryPublic.cards.locs')} - ${times.length} ${(0, trans_1.trans)('trialsSummaryPublic.cards.time')}`;
        }
        if (this.depth === 1) {
            for (let time of this.line.times) {
                if (!times.includes(time.time)) {
                    times.push(time.time);
                }
            }
            return `${times.length} ${(0, trans_1.trans)('trialsSummaryPublic.cards.time')}`;
        }
        if (this.depth === 2) {
            return `${this.line.date}`;
        }
        return "";
    }
    toggleLine() {
        this.$emit('toggleLine');
    }
    viewList() {
        this.$emit('viewList');
    }
    setDownloading() {
        this.isDownloading = true;
    }
    setDownloaded() {
        this.isDownloading = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ConfigurationSchemeLine.prototype, "line", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], ConfigurationSchemeLine.prototype, "depth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ConfigurationSchemeLine.prototype, "isDeployed", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ConfigurationSchemeLine.prototype, "isLast", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ConfigurationSchemeLine.prototype, "hasMatch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ConfigurationSchemeLine.prototype, "hasOwnMatch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ConfigurationSchemeLine.prototype, "theme", void 0);
ConfigurationSchemeLine = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            Button: bmk_ui_framework_1.Button,
            BulkDownloader: BulkDownloader_vue_1.default,
            ChevronRight: lucide_vue_next_1.ChevronRight,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            List: lucide_vue_next_1.List,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Dropdown: floating_vue_1.Dropdown
        },
    })
], ConfigurationSchemeLine);
exports.default = ConfigurationSchemeLine;
